<template>

    <header id="site__header">

        <div class="site__container pt-24">

            <div :class="menuDisplay" class="mb-24 items-center justify-between">
                <a
                    :class="menuLogoOrder"
                    :href="currentCompany.jobsite_url"
                    class="h-60 w-auto flex justify-center">
                    <img
                        :alt="currentCompany.name"
                        :src="logoUrl"
                        class="h-60"
                    >
                </a>

                <div :class="[menuButtonsOrder, logoPadding, menuButtonsAlignment]"
                     class="flex justify-center">
                    <a
                        id="home__back-to-website-button"
                        :class="menuLogoAlignment"
                        :href="currentCompany.website"
                        class="site__rounded--small border site__border--text-light h-40 items-center px-16 flex-none group flex max-w-full"
                    >
                        <span class="mr-8 truncate text-body-sm">
                            {{
                                labels.back_to_company_website[locale] ?
                                labels.back_to_company_website[locale] :
                                $t('company.back_to_company_website')
                            }}
                        </span>
                        <span
                            class="site__color--text opacity-25 group-hover:opacity-75 trans-ease flex justify-end overflow-visible">
                            <svg class="block fill-current" height="16" width="16"><path d="M16 0v6l-2.293-2.293-5 5-1.414-1.414 5-5L10 0h6zm-1 16H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h7v2H2v12h12V8h2v7a1 1 0 0 1-1 1z"/></svg>
                        </span>
                    </a>

                    <div
                        v-if="hasMultipleLanguages"
                        class="pl-12 mb-0"
                    >
                        <div class="relative text-body-sm" x-data="{ open: false }">

                            <button
                                class="focus:outline-none site__focus--outline-brand trans-ease hover:bg-primary-5 site__rounded--small px-16 h-40 flex items-center cursor-pointer"
                                x-on:click="open = !open"
                            >
                                <span class="mr-8">{{ $t('languages.' + locale + '.title') }}</span>
                                <span
                                    :style="{ 'border-top-color' : textHSLA }"
                                    class="dropdown-triangle trans-ease"
                                    x-bind:class="{'transform -rotate-180': open}"
                                ></span>
                            </button>

                            <ul
                                class="h-auto right-0 mt-8 bg-white border border-primary-5 absolute  site__rounded--small overflow-hidden shadow pt-16 trans-ease"
                                x-cloak
                                x-on:click.away="open = false"
                                x-show="open"
                                x-transition:enter="transition ease-out duration-300"
                                x-transition:enter-end="opacity-100 transform translate-y-0"
                                x-transition:enter-start="opacity-0 transform -translate-y-8"
                                x-transition:leave="transition ease-in duration-300"
                                x-transition:leave-end="opacity-0 transform -translate-y-8"
                                x-transition:leave-start="opacity-100 transform translate-y-0"
                            >
                                <li v-for="(link, language) in translationLinks"
                                    :key="language"
                                    class="mb-8 -mt-8"
                                >
                                    <a :href="link" class="block px-16 py-4 hover:bg-primary-5">
                                        {{ $t('languages.' + language + '.title') }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </header>

</template>

<script>
import { mapState } from 'pinia';
import { useCommonStore } from '../../state/common';
import { useBrandingStore } from '../../state/branding'
import {responsive, route } from '../../helpers';

export default {
    data: function () {
        return {
            alignX: 'start',
            alignY: 'end',
        }
    },
    computed: {
        ...mapState(useBrandingStore, ['preview', 'textHSLA']),
        ...mapState(useCommonStore, ['locale', 'currentCompany']),
        labels () {
            return this.currentCompany.jobsite ?
                this.currentCompany.jobsite.labels :
                {
                    'back_to_company_website': {}
                };
        },
        logoPadding () {
            return responsive(this.preview.type, 'pt-24 md:pt-0');
        },
        menuButtonsOrder () {
            return responsive(this.preview.type, 'order-1 md:order-2');
        },
        menuDisplay () {
            return responsive(this.preview.type, 'block md:flex');
        },
        menuButtonsAlignment() {
            let flexDirection = responsive(this.preview.type, 'flex-col md:flex-row');
            let alignItems = responsive(this.preview.type, 'items-center md:items-start');
            let gap = responsive(this.preview.type, 'gap-8 md:gap-0');
            return flexDirection + ' ' + alignItems + ' ' + gap;
        },
        menuLogoAlignment () {
            return responsive(this.preview.type, 'md:ml-auto');
        },
        menuLogoOrder () {
            return responsive(this.preview.type, 'order-2 md:order-1');
        },
        translationLinks () {

            let links = {};

            this.currentCompany.jobsite.active_languages.forEach(language => {

                if (language !== this.locale) {
                    if (Jobtoolz.translated_urls && Jobtoolz.translated_urls[language]) {
                        links[language] = Jobtoolz.translated_urls[language];
                    } else {
                        links[language] = route('jobsite.' + language + '.index');
                    }
                }
            });

            return links;
        },
        hasMultipleLanguages () {
            return this.currentCompany.jobsite.active_languages.length > 1;
        },
        logoUrl(){
            if(!this.currentCompany.logo_url){
                return '';
            }

            const url = new URL(this.currentCompany.logo_url);
            url.searchParams.append('h',60);

            return url.href;
        },
    }
}
</script>
